// extracted by mini-css-extract-plugin
export default {"collapseHeader":"collapse-header-Kb0Q9DC7Q1A5","title":"title-ZG5wbY5PXdGE","icon":"icon-I33pq7MLwLVN","close":"close-vhpfZJXL3UKh"};